import { IconDownload } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';
import { useGetDocument } from '../SignDocumentStep/useGetDocument';

const CREDIT_AGREEMENT_PATH = '/funding-requirements/sign-credit-agreement';

type TCreditAgreementStepProps = { status: TFundingRequirementStatus };

export const CreditAgreementStep = ({ status }: TCreditAgreementStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.credit_agreement_step.list_title"
                    defaultMessage="Read and sign your Credit Agreement"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 2 }}
                />
            }
            href={CREDIT_AGREEMENT_PATH}
            status={status}
            completedView={<CreditAgreementCompletedView />}
        />
    );
};

const CreditAgreementCompletedView = () => {
    const { downloadUrl, isLoading } = useGetDocument('master_loan_agreement');

    return (
        <div className="flex grow items-center justify-between gap-l pr-0 min-m:pr-s">
            <Text className="text-m font-med text-primary-10">
                <FormattedMessage
                    id="_.funding_requirements.credit_agreement_step.list_title"
                    defaultMessage="Read and sign your Credit Agreement"
                />
            </Text>
            {!isLoading && (
                <a
                    href={downloadUrl}
                    download
                    aria-label="Download credit agreement"
                    className="text-l text-primary-40"
                >
                    <IconDownload />
                </a>
            )}
        </div>
    );
};
